import React, { useContext } from "react";

// core components
import { Sidebar } from "core/AssetDownload";
import DownloadPhotoButton from "./components/DownloadPhotoButton";

import { PhotoBuyBox } from "../PhotoBuyBox";

import AssetDownloadContext from "core/AssetDownload/Context";

const PhotoDetailSidebar = () => {
    const { state } = useContext(AssetDownloadContext);
    const { isReadyForDownload } = state;

    return (
        <Sidebar>
            {isReadyForDownload ? <DownloadPhotoButton /> : <PhotoBuyBox />}
        </Sidebar>
    );
};

export default PhotoDetailSidebar;
